import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IAIAgentTemplate, IAIAgentTemplateFormData } from '../../extViewmodels/sdk/models/AI';

export function useCloneAIAgentTemplateMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (result: IAIAgentTemplate) => void;
} = {}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async ({
			originalId: _originalId,
			data,
			impersonationContext,
		}: {
			originalId: string;
			data: IAIAgentTemplateFormData;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			// Clone by creating a new agent template without the original ID
			return userSession.webServiceHelper.callAsync<IAIAgentTemplate>(
				Api.ImpersonationBroker.composeApiUrl({ impersonationContext, urlPath: 'aiagenttemplate' }),
				'POST',
				data
			);
		},
		onError,
		onSuccess,
	});
}
